import { Link } from 'react-router-dom';
import EmptyState from '../components/EmptyState';

/** 404 */
export default function NotFound() {
  return (
    <div className="login">
      <div className="login__card">
        <EmptyState
          icon="✷"
          title="404 · 页面不存在"
          hint="您访问的路径不在指挥中心范围内。"
        />
        <div style={{ textAlign: 'center' }}>
          <Link className="btn btn--primary" to="/map">
            返回全国态势
          </Link>
        </div>
      </div>
    </div>
  );
}
